import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap'
import { useLocation } from "react-router-dom";
import Moment from 'moment';

export default function PaymentSuccess() {
	let query = new URLSearchParams(useLocation().search);

	const [summary, setSummary] = useState([]);
	const [isGetSummary, setIsGetSummary] = useState(false);
	const [isSentMail, setIsSentMail] = useState(false);
	const [modalShow, setModalShow] = useState(false);

	useEffect(() => {
		if (isGetSummary === false) {
			axios.get('/api/order/' + query.get("paymentID"))
				.then(res => {
					var trans = res.data[0]['trans'];
					setSummary({
						name: trans.name,
						idNo: trans.idno,
						contactNo: trans.contactNo,
						emailAdd: trans.emailAdd,
						gender: trans.gender,
						dob: Moment(trans.dob).format('YYYY-MM-DD'),
						applicantType: trans.applicantType,
						nationality: trans.nationality,
						address: trans.address,
						insurer: trans.insurer,
						planName: trans.planName,
						benefit: trans.benefit,
						premium: trans.premium,
						serviceTax: trans.sst,
						stampDuty: trans.stampDuty,
						totalPay: trans.totalPay,
						promo: trans.promo,
						periodFrom: Moment(trans.periodFrom).format('YYYY-MM-DD'),
						periodTo: Moment(trans.periodTo).format('YYYY-MM-DD'),
						TransactionNo: trans.TransactionNo,
						payment_status: trans.payment_status,
						txn_message: trans.txn_message,
						policyNoPrepend: trans.policyNoPrepend,
						policyNo: trans.policyNo
					});
					setIsGetSummary(true);
				})
		}
	}, [query]);

	useEffect(() => {
		if (isGetSummary === true && summary.length !== 0 && isSentMail === false) {
			axios({
				method: 'post',
				url: '/api/sendsuccessfulCasemail',
				"headers": {
					"content-type": "application/json",
				},
				data: {
					setSuccessCases: summary
				}
			})
				.then(function (response) {
					setIsSentMail(true);
				})
				.catch(function (error) {
					console.log(error);
				})
		}
	}, [summary]);

	return (
		<div id="product-hero">
			{isGetSummary ?
				<section id="body">
					<PromptMessage show={modalShow} onHide={() => setModalShow(false)} />
					<div className="container">
						<div className="row">
							<div className="col-12">
								<div className="row shadow title position-relative">
									<div className="col-12">
										<h2 className="text-center m-5 text-white font-weight-bold">Payment Successful</h2>
									</div>
								</div>
								<div className="row content">
									<div className="col-1"></div>
									<div className="col-10 shadow bg-white rounded">
										<p className="mt-4">Hi, {summary.name}</p>
										<p>Thank you for your payment.</p>
										<p>The insurance coverage will only take effect upon approval process has been completed by Tune Insurance Malaysia Berhad.</p>
										<p>For any inquiries, please email us at <a href="mailto:instaPol@howdengroup.com" target="_blank">instaPol@howdengroup.com</a></p>

										<div className="card-deck mb-3 text-center">
											<div className="card mb-4 box-shadow">
												<div className="card-header" style={{ backgroundColor: "#c7ddea" }}>
													<h4 className="my-0" style={{ backgroundColor: "#c7ddea" }}>Purchase Summary</h4>
												</div>
												<div className="card-body p-0">
													<table className="table table-bordered table-condensed mb-0">
														<tbody>
															<tr>
																<td style={{ wordWrap: "break-word", width: "50%" }}>Product <br /></td>
																<td style={{ wordWrap: "break-word", width: "50%" }}>Critical Illness Insurance {summary.planName}</td>
															</tr>
															<tr>
																<td style={{ wordWrap: "break-word", width: "50%" }}>Insurer <br /></td>
																<td style={{ wordWrap: "break-word", width: "50%" }}>{summary.insurer}</td>
															</tr>
															<tr>
																<td style={{ wordWrap: "break-word", width: "50%" }}>Transaction No.</td>
																<td style={{ wordWrap: "break-word", width: "50%" }}>{summary.TransactionNo}</td>
															</tr>
															<tr>
																<td style={{ wordWrap: "break-word", width: "50%" }}>Amount</td>
																<td style={{ wordWrap: "break-word", width: "50%" }}>{"RM " + summary.totalPay.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>

										<div className="row">
											<div className="col-12 mb-5">
												<a href={`https://howden-mia-dev.instapol.my/?r=${summary.promo}`} className="btn btn-primary mt-4 mb-4" role="button">Back to Home</a>
											</div>
										</div>
										<div className="row mt-4">
											<label className="col-12 col-form-label text-center">You might also be interested in</label>
										</div>
										<div id="othProducts" className="row justify-content-around mb-3">
											<div className="col-sm-3">
												<a href="https://instapol.my/travel">
													<img className="img-fluid" src="../images/travel-button.png" loading="lazy" />
												</a>
											</div>
											<div className="col-sm-3">
												<a href="https://motor.instapol.my/">
													<img className="img-fluid" src="../images/motor-button.png" loading="lazy" />
												</a>
											</div>
											{/* <div className="col-sm-3">
												<a href="https://howden-wmotor.instapol.my/landing">
													<img className="img-fluid" src="../images/extended-motor-button.png" loading="lazy" />
												</a>
											</div> */}
										</div>
									</div>
									<div className="col-1"></div>
								</div>
							</div>
						</div>
					</div>
				</section>
				:
				<div className="text-center mt-5">
					<img src="../images/loading.gif" />
					<br />
					Please wait
				</div>
			}
		</div>
	);
}

function PromptMessage(props) {
	return (
		<Modal {...props}
			aria-labelledby="contained-modal-title-vcenter"
			centered
		>
			<Modal.Header>
				<Modal.Title className="container-fluid">
					<div className="row">
						<button type="button" className="close" onClick={props.onHide}><i className="fa fa-times-circle text-right"></i></button>
					</div>
					<div className="row">
						<div className="col-12 text-center text-primary">
							<label className="col-form-label">Get your <strong>FREE*</strong> PA, Covid 19 &
								<br />Dengue cover up to RM10,000</label>
						</div>
					</div>
					<div className="row mt-3">
						<div className="col-12 text-center">
							<a className="btn btn-success badge-pill btn-lg px-5" href="https://instapol.my/">Click Here</a>
						</div>
					</div>



				</Modal.Title>
			</Modal.Header>
		</Modal>
	);
}